import Vue from 'vue';
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const numberFormats = {
    "en-CA": {
        currency: {
            style: "currency",
            currency: "CAD"
        }
    },
    "fr-CA": {
        currency: {
            style: "currency",
            currency: "CAD"
        }
    },
}

const messages = {
    "en" : require('../locales/en.json'),
    "fr" : require('../locales/fr.json'),
    "es": require('../locales/es.json'),
};
export default new VueI18n({
    locale : Vue.prototype.$sessionStorage.getItem('locale') || window.locale || 'en',
    fallbackLocale : "en",
    messages : messages,
    numberFormats : numberFormats
});
